import { graphql } from '@/generated/gql';

export const SOURCING_CASE_QUOTE_QUERY = graphql(/* GraphQL */ `
  query SourcingCaseQuote($id: UUID!) {
    tesseract {
      sourcingCase(id: $id) {
        id
        status
        sequenceNumber
        createdAt
        updatedAt
        isNegotiationEnabled
        isSupplierUploadAllowed
        isAwardable
        issues {
          id
          status
          variant
        }
        supplier {
          id
          name
          supplierId
          contact {
            id
            firstName
            lastName
            email
            internalId
          }
        }
        quote {
          id
          status
          createdAt
          currency
          supplierReference
          validFrom
          validTo
          paymentTermsId
          incoTermsId
          lineItems {
            id
            sequence
            createdAt
            title
            description
            unitId
            commodityId
            deliveryLocationId
            status
            organizationId
            priceUnit
            pricePerPriceUnit
            pricePerUnit
            minimumOrderQuantity
            quantity
            discountedPricePerUnit
            discountedPricePerPriceUnit
            totalDiscountedValue
            totalValue
            demandRequestItemId
            bidDeclinedReason
            bidDeclinedReasonText
            isAwardable
          }
        }
      }
    }
  }
`);
